import ButtonSkeleton from '../../../../../components/Button/skeleton';

const EditPublishPreferencesSkeleton = () => {
  // oversizing the buttons to look good
  return <ButtonSkeleton size="small" width={34} height={34} />;
};

export default EditPublishPreferencesSkeleton;
